import React, { useState, useEffect, useRef } from 'react';
import { FiTruck } from 'react-icons/fi';
import { BiBox } from 'react-icons/bi';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { AiOutlinePlus } from 'react-icons/ai';
import { IoIosArrowDown } from "react-icons/io";
import { ingredients, autoShipPlans, productImages, accordionItems } from '../constants/gruns';

const GetYourGruns = () => {
    const [selectedImage, setSelectedImage] = useState(productImages[0]);
    const [openAccordions, setOpenAccordions] = useState([]);
    const [openIngredient, setOpenIngredient] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('Low Sugar');
    const modalRef = useRef(null);

    useEffect(() => {
        // Handle body scrolling
        if (isModalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        // Cleanup function
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isModalOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModalOpen(false);
            }
        };

        if (isModalOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isModalOpen]);

    const toggleAccordion = (index) => {
        setOpenAccordions(prev => {
            if (prev.includes(index)) {
                return prev.filter(item => item !== index);
            } else {
                return [...prev, index];
            }
        });
    };

    return (
        <div className="bg-[white] py-8 md:py-16">
            <div className="max-w-[90%] md:max-w-[70%] mx-auto">
                <div className="text-center space-y-3 md:space-y-4">
                    <h2 className="text-[#008037] text-[28px] md:text-[40px] font-semibold">
                        real buzz. no booze.<sup className="text-[28px] md:text-[35px]">®</sup>
                    </h2>
                    <p className="max-w-[80%] md:max-w-full mx-auto text-base  text-black tracking-widest">
                        0.0% alcohol | 4.5% Ketohol | 0 carbs | 90 calories
                    </p>
                    <div className="flex flex-col md:flex-row items-center justify-center gap-2 text-base md:text-lg">
                        <div className="flex items-center">
                            <span className="text-[#008037]">★★★★★</span>
                            <span className="ml-2">4.5 stars from 1,000 reviews</span>
                        </div>
                        <span className="text-[#008037] hidden md:inline">|</span>
                        <span className="text-[#008037] font-medium">100,000+ customers</span>
                    </div>
                </div>

                {/* Two-column section */}
                <div className="flex flex-col md:flex-row gap-8 justify-between mt-6 md:mt-10">
                    <div className="w-full md:w-1/2 bg-white rounded-xl">
                        <div>
                            <img
                                src={selectedImage}
                                alt="gruns"
                                className='rounded-xl w-full h-[300px] md:h-[450px] border border-[#000] object-cover'
                            />
                            <div className='mt-2 flex items-center gap-2 overflow-x-auto pb-2'>
                                {productImages.map((image, index) => (
                                    <img
                                        key={index}
                                        src={image}
                                        alt={`gruns ${index + 1}`}
                                        className={`rounded-md w-[48px] h-[48px] md:w-[65px] md:h-[65px] border cursor-pointer transition-all duration-200 ${selectedImage === image
                                            ? 'border-[#008037] border-2 opacity-100'
                                            : 'border-[#000] hover:border-[#008037] opacity-50 hover:opacity-75'
                                            }`}
                                        onClick={() => setSelectedImage(image)}
                                    />
                                ))}
                            </div>
                            <div className='bg-[#dfefe7] mt-4 py-2 border border-[#000] rounded-[12px] text-center cursor-pointer' onClick={() => setIsModalOpen(true)}>
                                <button
                                    className='text-sm font-medium text-black'

                                >
                                    View Nutrition Label
                                </button>
                            </div>

                            {/* Nutrition Label Modal */}
                            {isModalOpen && (
                                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center ">
                                    <div ref={modalRef} className="bg-white rounded-lg p-6 px-4 pt-[40px] md:pt-6 md:px-[100px] max-w-[90%] md:max-w-[85%] h-[85vh] mt-[70px] relative w-full overflow-hidden">
                                        <button
                                            className="absolute top-4 right-4 text-black"
                                            onClick={() => setIsModalOpen(false)}
                                        >
                                            ✕
                                        </button>
                                        <div className="mt-4">
                                            <div>
                                                <h2 className="text-[#008037] text-center text-2xl font-semibold mb-4">CHOOSE YOUR OFFER</h2>
                                                <div className="flex rounded-[50px] border-2 border-[#809389] overflow-hidden">
                                                    <button
                                                        className={`flex-1 py-3 px-4 text-center transition-colors duration-200 ${activeTab === 'Low Sugar'
                                                            ? 'bg-[#008037] text-white'
                                                            : 'bg-white text-black'
                                                            }`}
                                                        onClick={() => setActiveTab('Low Sugar')}
                                                    >
                                                        Pina Colada 
                                                    </button>
                                                    <button
                                                        className={`flex-1 py-3 px-4 text-center transition-colors duration-200 ${activeTab === 'Sugar-Free'
                                                            ? 'bg-[#008037] text-white'
                                                            : 'bg-white text-black'
                                                            }`}
                                                        onClick={() => setActiveTab('Sugar-Free')}
                                                    >
                                                        Ginger Mule
                                                    </button>
                                                </div>
                                                <div className="flex rounded-[50px] border-2 border-[#809389] overflow-hidden">
                                                    <button
                                                        className={`flex-1 py-3 px-4 text-center transition-colors duration-200 ${activeTab === 'Low Sugar'
                                                            ? 'bg-[#008037] text-white'
                                                            : 'bg-white text-black'
                                                            }`}
                                                        onClick={() => setActiveTab('Low Sugar')}
                                                    >
                                                        Strawberry Spritz
                                                    </button>
                                                    <button
                                                        className={`flex-1 py-3 px-4 text-center transition-colors duration-200 ${activeTab === 'Sugar-Free'
                                                            ? 'bg-[#008037] text-white'
                                                            : 'bg-white text-black'
                                                            }`}
                                                        onClick={() => setActiveTab('Sugar-Free')}
                                                    >
                                                        Raw (Nasty)
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="mt-4">
                                                {activeTab === 'Low Sugar' ? (
                                                    <div className='h-[453px] overflow-y-auto scrollbar-hide'>
                                                        <div className='hidden md:block'>
                                                            <img
                                                                src="https://cdn.shopify.com/s/files/1/0550/9614/8034/files/Nutrition_Label_LS_-_Adults_B_V2_-_Desktop_fe5767de-bac9-4be0-b7a8-56582eacd31a.png?v=1730948947&width=1800"
                                                                alt="low sugar"
                                                                className='w-full object-contain'
                                                            />
                                                        </div>

                                                        <div className='block md:hidden pb-4'>
                                                            <img
                                                                src="https://cdn.shopify.com/s/files/1/0550/9614/8034/files/Nutrition_Label_LS_-_Adults_B_V2_Mobile.png?v=1730948947&width=820"
                                                                alt="low sugar"
                                                                className='w-full object-contain'
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='h-[453px] overflow-y-auto scrollbar-hide'>
                                                        <div className='hidden md:block'>
                                                            <img
                                                                src="https://cdn.shopify.com/s/files/1/0550/9614/8034/files/Nutrition_Label_SF_-_Adults_B_V2_-_Desktop.png?v=1730948947&width=1800"
                                                                alt="sugar-free"
                                                                className='w-full object-contain'
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Shipping and Guarantee Information */}
                            <div className="mt-1 md:mt-3 space-y-3 md:space-y-4 p-4 px-0">
                                <div className="flex items-center gap-3 text-black">
                                    <FiTruck className="text-[#008037] text-xl md:text-2xl" />
                                    <span className="text-xs md:text-sm font-medium">Ships within 24 Hours Mon-Fri</span>
                                </div>
                                <div className="flex items-center gap-3 text-black">
                                    <BiBox className="text-[#008037] text-xl md:text-2xl" />
                                    <span className="text-xs md:text-sm font-medium">FREE avg 2-day shipping today</span>
                                </div>
                                <div className="flex items-center gap-3 text-black">
                                    <RiMoneyDollarCircleLine className="text-[#008037] text-xl md:text-2xl" />
                                    <span className="text-xs md:text-sm font-medium">30-Day Money Back Guarantee</span>
                                </div>
                                <div className="text-sm mt-2 text-black">
                                    HSA/FSA Eligible with Truemed. <a href="#" className="text-[#000] underline font-medium">Learn More.</a>
                                </div>
                            </div>

                            {/* Accordion Section */}
                            <div className=" md:mt-6">
                                {accordionItems.map((item, index) => (
                                    <div key={index} className="">
                                        <button
                                            className={`${openAccordions.includes(index) ? 'w-full justify-between border-none' : 'border-b border-gray-900'} py-3 md:py-4 flex gap-4 items-center text-left`}
                                            onClick={() => toggleAccordion(index)}
                                        >
                                            <span className="text-[13px] md:text-[15px] font-medium text-black">{item.title}</span>
                                            <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-2 border-[#008037] flex items-center justify-center">
                                                <AiOutlinePlus className="text-[#008037] text-[10px] md:text-[12px]" />
                                            </div>
                                        </button>
                                        {openAccordions.includes(index) && (
                                            <div className="px-2 pb-3 md:pb-4 border-b border-gray-900">
                                                <div className="text-gray-600">{item.content}</div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-1/2 bg-white rounded-md">
                        <div>
                            <h2 className="text-[#007e40] text-center text-2xl font-semibold mb-2">CHOOSE YOUR OFFER</h2>

                            <div className="flex rounded-[16px] border border-[#000] overflow-hidden mb-2">
                                <button
                                    className={`flex-1 py-2.5 px-4 text-center transition-colors duration-200 ${activeTab === 'Low Sugar'
                                        ? 'bg-[#007e40] text-white'
                                        : 'bg-white text-black'
                                        }`}
                                    onClick={() => setActiveTab('Low Sugar')}
                                >
                                    Pina Colada
                                </button>
                                <button
                                    className={`flex-1 py-2.5 px-4 text-center transition-colors duration-200 ${activeTab === 'Sugar-Free'
                                        ? 'bg-[#007e40] text-white'
                                        : 'bg-white text-black'
                                        }`}
                                    onClick={() => setActiveTab('Sugar-Free')}
                                >
                                    Ginger Mule
                                </button>
                            </div>
                            <div className="flex rounded-[16px] border border-[#000] overflow-hidden mb-2">
                                <button
                                    className={`flex-1 py-2.5 px-4 text-center transition-colors duration-200 ${activeTab === 'Low Sugar'
                                        ? 'bg-[#007e40] text-white'
                                        : 'bg-white text-black'
                                        }`}
                                    onClick={() => setActiveTab('Low Sugar')}
                                >
                                    Strawberry Spritz
                                </button>
                                <button
                                    className={`flex-1 py-2.5 px-4 text-center transition-colors duration-200 ${activeTab === 'Sugar-Free'
                                        ? 'bg-[#007e40] text-white'
                                        : 'bg-white text-black'
                                        }`}
                                    onClick={() => setActiveTab('Sugar-Free')}
                                >
                                    Raw (Nasty)
                                </button>
                            </div>
                            <div className="relative w-full my-4 mt-0">
                                <div className="absolute top-[5px] left-[5px] right-[-5px] bottom-[-5px] bg-[#000] rounded-[25px]"></div>
                                <div className="relative rounded-[25px] border border-black p-4 bg-white">
                                    <h3 className="font-semibold text-[17px] text-gray-900 mb-2">AutoShip & Save</h3>

                                    <div className="space-y-2">
                                        {autoShipPlans.plans.map((plan, index) => (
                                            <div key={index} className={`${plan.style} border border-[#000] rounded-[15px] p-3 relative`}>
                                                <div className="absolute top-3 right-3">
                                                    <span className="bg-[#007e40] text-white text-sm px-3 py-1 rounded-full">{plan.discount}% off</span>
                                                </div>
                                                <p className="font-medium text-black">{plan.name}</p>
                                                <div className="flex items-center gap-2 mb-1">
                                                    <span className="text-lg font-semibold">${plan.price}</span>
                                                    <span className="text-[#000] line-through text-sm">${plan.originalPrice}</span>
                                                </div>
                                                <p className="text-[#007e40] text-sm">${plan.perDay} Per Day</p>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="mt-4 space-y-2">
                                        {autoShipPlans.benefits.map((benefit, index) => (
                                            <div key={index} className="flex items-center gap-2 text-black">
                                                <svg className="text-[#007e40] w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                <span className="text-sm">{benefit}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="relative w-full my-4">
                                        <div className="absolute top-[7px] left-[5px] w-full h-full bg-[#000] rounded-full"></div>
                                        <button className="relative bg-[#007e40] border border-[#000] text-white font-semibold py-3 md:py-3 rounded-full hover:translate-y-[1px] hover:translate-x-[1px] transition-transform duration-200 text-md w-full text-center">
                                            Start Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="rounded-[25px] border border-black p-3 md:p-4 py-2">
                            <h3 className="font-medium text-black text-sm md:text-base">Try Once</h3>
                            <div className="flex items-center gap-2">
                                <span className="text-base md:text-lg font-semibold">$54.39</span>
                                <span className="text-[#000] line-through text-sm md:text-base">$87.99</span>
                            </div>
                            <p className="text-[#008037] text-xs md:text-sm font-medium">$1.94 Per Day</p>
                        </div>



                        <div className="mt-6 md:mt-8">
                            <h3 className="text-center font-bold text-lg md:text-xl mb-6 md:mb-8 text-black">TASTE LIKE</h3>
                            <div className="flex justify-center gap-3 md:gap-4 items-center">
                                <div className="flex flex-col items-center gap-2">
                                    <div className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] rounded-full border-1 border-[#008037] flex items-center justify-center">
                                        <img src="https://cdn.shopify.com/s/files/1/0550/9614/8034/files/Capa_1_e7feefca-3152-4112-a361-ef6fa6e97dac.svg?v=1730946282" alt="" className='w-full h-full object-cover' />
                                    </div>
                                    <p className="text-sm font-medium">FRESH & LIGHT</p>
                                </div>

                                <div className="flex flex-col items-center gap-2">
                                    <div className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] rounded-full border-1 border-[#008037] flex items-center justify-center">
                                        <img src="https://cdn.shopify.com/s/files/1/0550/9614/8034/files/Capa_1_1_f84cd490-bda7-418b-ba2d-3705247e5f47.svg?v=1730946282" alt="" className='w-full h-full object-cover' />
                                    </div>
                                    <p className="text-sm font-medium">STRAWBERRY</p>
                                </div>

                                <div className="flex flex-col items-center gap-2">
                                    <div className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] rounded-full border-1 border-[#008037] flex items-center justify-center">
                                        <img src="https://cdn.shopify.com/s/files/1/0550/9614/8034/files/Capa_1_2_f33c3852-cd7c-4914-a2f1-d3951b279c02.svg?v=1730946282" alt="" className='w-full h-full object-cover' />
                                    </div>
                                    <p className="text-sm font-medium">SWEET GREENS</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-8 md:mt-12 space-y-3 md:space-y-4">
                            {ingredients.map((item, index) => (
                                <div key={index}>
                                    <div
                                        className="flex items-center gap-3 relative group cursor-pointer"
                                        onClick={() => setOpenIngredient(openIngredient === index ? null : index)}
                                    >
                                        <div className="w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full bg-[#008037] overflow-hidden">
                                            <img
                                                src={item.image}
                                                alt={item.name}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>
                                        <span className="text-sm text-black font-medium">{item.name}</span>
                                        <IoIosArrowDown
                                            className={`block md:hidden ml-auto text-[#008037] transition-transform duration-200 ${openIngredient === index ? 'rotate-180' : ''}`}
                                            size={20}
                                        />
                                        <div className="absolute left-0 bottom-[calc(100%+10px)] w-full bg-white px-3 md:px-4 py-2 md:py-3 rounded-[10px] text-sm opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] border border-[#E5E7EB] z-10 hidden md:block">
                                            <h3 className="font-medium text-black mb-1 text-xs md:text-sm">{item.name}</h3>
                                            <p className="text-[11px] md:text-[13px] text-black">{item.description}</p>
                                        </div>
                                    </div>
                                    {/* Mobile dropdown */}
                                    {openIngredient === index && (
                                        <div className="block md:hidden mt-2 pl-[52px]">
                                            <p className="text-[13px] text-black">{item.description}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GetYourGruns;
